import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'src/components/queryProvider';
import { IBulkCreateSchedulePayload } from 'src/interfaces/Schedule';
import { lang, queryKeys, requestCCApi } from 'src/utils';

export const useBulkCreateSchedule = () => {
  return useMutation({
    mutationFn: bulkCreateSchedule,
    onSuccess: (_, variable) => {
      // clear cache of calendar endpoint under the updated location groups
      variable.data.forEach((scheduleItem) => {
        queryClient.invalidateQueries(
          queryKeys.getCalendarEvents.details([
            String(scheduleItem.location_group_id),
          ]),
        );
      });
    },
  });
};

const bulkCreateSchedule = async (
  payload: IBulkCreateSchedulePayload,
): Promise<{
  ids: number[];
}> => {
  const response = await requestCCApi(
    {
      url: '/schedules',
      method: 'POST',
      data: payload,
    },
    true,
    lang.publishFailed,
  );

  return response;
};
